import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as PayAndGoActions from '../actions/pay-and-go.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { TechnicalError } from '@dch/products-business-logic';
import { PrepaidSettingsService } from '../../services/prepaid-settings.service';

@Injectable({
  providedIn: 'root',
})
export class PayAndGoEffects {
  @Effect()
  orderPayAndGo$: Observable<Action> = this.actions$.pipe(
    ofType(PayAndGoActions.ORDER_PAY_AND_GO),
    mergeMap((action: PayAndGoActions.OrderPayAndGo) =>
      this.prepaidSettingsService
        .updatePrepaidSettingsMsisdn(
          action.payload.msisdn,
          action.payload.proxiWorld,
        )
        .pipe(
          map(
            (responseEntity: IEntity<any>) =>
              new PayAndGoActions.OrderPayAndGoSuccess(responseEntity.value),
          ),
          catchError((error1: IEntity<TechnicalError>) =>
            of(
              new PayAndGoActions.OrderPayAndGoFailure(
                error1.errorData as TechnicalError,
              ),
            ),
          ),
        ),
    ),
  );

  constructor(
    private actions$: Actions,
    private prepaidSettingsService: PrepaidSettingsService,
  ) {}
}
